export default __webpack_public_path__ + "static/media/thumb04_invitation3@2x.5722659f.png";